/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M408.447 99.323a2.559 2.559 0 002.546-2.549V33.537a2.53 2.53 0 00-2.546-2.53H105.383a2.53 2.53 0 00-2.546 2.53v63.237a2.559 2.559 0 002.546 2.549h303.064zM368.682 335.553v95.794H145.137V295.598h223.545v39.955zM509.127 132.6H4.96c-2.183 0-3.964 1.782-3.964 3.985v194.98c0 2.204 1.78 3.987 3.964 3.987h97.823v114.592c0 13.012 10.57 23.628 23.59 23.628h261.092c13.02 0 23.609-10.616 23.609-23.628V335.553h98.053a3.981 3.981 0 003.983-3.986v-194.98a3.981 3.981 0 00-3.983-3.986z" />
    </g>
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconPrint = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconPrint.defaultProps = {
  theme,
};
IconPrint.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconPrint.displayName = 'IconPrint';
export { IconPrint };
